module.exports = __webpack_public_path__ + "cf2b0f968e05b234ef376579641717f1.svg";